import { list } from "./list";
import { listGroups } from "./listGroups";

export const SupplementsEndpoint = {
  list,
  listGroups,
};
